/*
 * File Created: Tuesday, 2nd May 2023 10:19:56 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Static } from "../types/static/StaticModal.type";
import banner from "../assets/images/sst_2.webp";
import banner1 from "../assets/images/sst_3.jpg";
// import banner2 from "../assets/images/sst_3_nobg.png";
import product2nobg from "../assets/images/sst_7_nobg.png";
import product3nobg from "../assets/images/sst_8_nobg.png";
import indigo1 from "../assets/images/bio_indigo1.webp";
import indigo2 from "../assets/images/bio_indigo2.webp";
import black1 from "../assets/images/black1.webp";
import black2 from "../assets/images/black2.png";
import olive1 from "../assets/images/olive1.webp";
import olive2 from "../assets/images/olive2.webp";
import red1 from "../assets/images/red1.webp";
import red2 from "../assets/images/red2.png";
import natural1 from "../assets/images/natural1.webp";
import natural2 from "../assets/images/natural2.webp";
import sst_footer_logo from "../assets/images/sst-banner-resize.webp";


export const staticData: Static = {
  banner: {
    title: "",
    subtitle: "Sanajing Sana Thambal",
    imageSrc: banner,
  },
  siteProfile: {
    name: "Sanajing Sana Thambal",
    description: "Eco friendly, Anti-bacterial, Sustainable textiles",
    address: "House-no 76 Thanga, Moirang, Bishnupur",
    state: "Manipur",
    country: "India",
    area_code: "795133",
    email: "bijyashantitongbram@gmail.com",
    phoneNo: "+917630873621",
    establishedAt: "",
    socialMedia: [
      { name: "Facebook", src: "https://www.facebook.com/sanajingsanathambal.thanga" },
      // { name: "Twitter", src: "#" },
      { name: "Instagram", src: "www.instagram.com/sanajingsanathambal" },
      // { name: "Youtube", src: "#" },
      // { name: "Pinterest", src: "#" },
    ],
    logo: [
      {
        id: "1",
        name: "Small",
        src: "",
        type: "small",
      },
      {
        id: "2",
        name: "Medium",
        src: sst_footer_logo,
        type: "medium",
      },
    ],
  },
  sections: [
    {
      id: "1",
      title: "In this look",
      description: "100% pure lotus fibre scarf. It has two variants in size of 12-inch width 60-inch length and 15-inch width 70-inch length",
      items: [
        {
          id: "01",
          name: "Bio-Indigo Scarf with Fringes",
          category: [],
          colors: [{ id: "1", name: "#374d6a" }],
          description: "100% pure lotus fiber scarf",
          discount: 0,
          mrp: 0,
          cp: 0,
          sp: 0,
          images: [
            {
              id: "1",
              type: "top",
              src: indigo1,
            },
            {
              id: "2",
              type: "left",
              src: indigo2,
            },
          ],
          additionalInformation: {
            size: [
             {
              id: "1",
              length: "60",
              width: "12",
              unit: "inch"
             },
             {
              id: "1",
              length: "70",
              width: "15",
              unit: "inch"
             },
            ]
          }
        },
        {
          id: "02",
          name: "Black Scarf with Fringes",
          category: [],
          colors: [{ id: "1", name: "black" }],
          description: "100% pure lotus fiber scarf",
          discount: 0,
          mrp: 0,
          cp: 0,
          sp: 0,
          images: [
            {
              id: "1",
              type: "top",
              src: black1,
            },
            {
              id: "2",
              type: "right",
              src: black2,
            },
          ],
          additionalInformation: {
            size: [
             {
              id: "1",
              length: "60",
              width: "12",
              unit: "inch"
             },
             {
              id: "1",
              length: "70",
              width: "15",
              unit: "inch"
             },
            ]
          }
        },
      ],
      banner: {
        id: "01",
        imageURL: banner1,
        title: "Spring into Style with Fringed Scarves",
        priceRange: {
          startPrice: "₹129.69",
          endPrice: "₹1259.72",
        },
        description: [
          {
            id: "1",
            name: "A bio indigo scarf with fringes ",
          },
          {
            id: "2",
            name: "A black scarf with fringes",
          },
        ],
      },
    },
    {
      id: "2",
      title: "In this look",
      description: "100% pure lotus fibre scarf. It has two variants in size of 12-inch width 60-inch length and 15-inch width 70-inch length",
      items: [
        {
          id: "07",
          name: "Brown Scarf with Fringes",
          category: [],
          colors: [{ id: "1", name: "#584127" }],
          description: "100% pure lotus fiber scarf",
          discount: 0,
          mrp: 0,
          cp: 0,
          sp: 0,
          images: [
            {
              id: "1",
              type: "top",
              src: olive1,
            },
            {
              id: "2",
              type: "left",
              src: olive2,
            },
          ],
          additionalInformation: {
            size: [
             {
              id: "1",
              length: "60",
              width: "12",
              unit: "inch"
             },
             {
              id: "1",
              length: "70",
              width: "15",
              unit: "inch"
             },
            ]
          }
        },
        {
          id: "08",
          name: "Ruby Red Scarf with Fringes",
          category: [],
          colors: [{ id: "1", name: "red" }],
          description: "100% pure lotus fiber scarf",
          discount: 0,
          mrp: 0,
          cp: 0,
          sp: 0,
          images: [
            {
              id: "1",
              type: "top",
              src: red1,
            },
            {
              id: "2",
              type: "right",
              src: red2,
            },
          ],
          additionalInformation: {
            size: [
             {
              id: "1",
              length: "60",
              width: "12",
              unit: "inch"
             },
             {
              id: "1",
              length: "70",
              width: "15",
              unit: "inch"
             },
            ]
          }
        },
        {
          id: "09",
          name: "Natural Scarf with Fringes",
          category: [],
          colors: [{ id: "1", name: "#888679" }],
          description: "100% pure lotus fiber scarf",
          discount: 0,
          mrp: 0,
          cp: 0,
          sp: 0,
          images: [
            {
              id: "1",
              type: "top",
              src: natural1,
            },
            {
              id: "2",
              type: "right",
              src: natural2,
            },
          ],
          additionalInformation: {
            size: [
             {
              id: "1",
              length: "60",
              width: "12",
              unit: "inch"
             },
             {
              id: "1",
              length: "70",
              width: "15",
              unit: "inch"
             },
            ]
          }
        },
      ],
      banner: {
        id: "02",
        imageURL: banner1,
        title: "The Perfect Spring Accessory",
        priceRange: {
          startPrice: "₹129.69",
          endPrice: "₹1259.72",
        },
        description: [
          {
            id: "1",
            name: "Brown Scarf with Fringes",
          },
          {
            id: "2",
            name: "Ruby red Scarf with Fringes",
          },
          {
            id: "3",
            name: "Natural Scarf with Fringes",
          },
        ],
      },
    },
    {
      id: "3",
      title: "In this look",
      description: "Hand woven lotus fabric Shawl. It has two variants in size of 21-inch width 70-inch length and 28-inch width 75-inch length",
      items: [
        {
          id: "05",
          name: "Natural Shawl",
          category: [],
          colors: [{ id: "1", name: "#cfcac6" }],
          description: "Hand woven lotus fabric Shawl",
          discount: 0,
          mrp: 0,
          cp: 0,
          sp: 0,
          images: [
            {
              id: "1",
              type: "top",
              src: product2nobg,
            },
          ],
          additionalInformation: {
            size: [
             {
              id: "1",
              length: "60",
              width: "12",
              unit: "inch"
             },
             {
              id: "1",
              length: "70",
              width: "15",
              unit: "inch"
             },
            ]
          }
        },
        {
          id: "06",
          name: "Purple Shawl",
          category: [],
          colors: [{ id: "2", name: "#988ecb" }],
          description: "Hand woven lotus fabric Shawl",
          discount: 0,
          mrp: 0,
          cp: 0,
          sp: 0,
          images: [
            {
              id: "1",
              type: "top",
              src: product3nobg,
            },
          ],
          additionalInformation: {
            size: [
             {
              id: "1",
              length: "60",
              width: "12",
              unit: "inch"
             },
             {
              id: "1",
              length: "70",
              width: "15",
              unit: "inch"
             },
            ]
          }
        },
      ],
      banner: {
        id: "03",
        imageURL: banner1,
        title: "Spring into Style with a Shawl",
        priceRange: {
          startPrice: "₹5673.02",
          endPrice: "₹9999.90",
        },
        description: [
          {
            id: "1",
            name: "A natural colour shawl",
          },
          {
            id: "2",
            name: "A purple colour shawl",
          },
        ],
      },
    },
    // {
    //   id: "3",
    //   title: "In this look",
    //   description: "Some details about the product",
    //   items: [
    //     {
    //       id: "01",
    //       name: "Blue Black Jogger Pants",
    //       category: [
    //         { id: "1", name: "Shoes" },
    //         { id: "2", name: "Clothing" },
    //         { id: "3", name: "Men" },
    //       ],
    //       colors: [{ id: "1", name: "green" }],
    //       description: "Some discription",
    //       discount: 0,
    //       mrp: 129.69,
    //       cp: 0,
    //       sp: 0,
    //       images: [
    //         {
    //           id: "1",
    //           type: "top",
    //           src: product1,
    //         },
    //       ],
    //     },
    //     {
    //       id: "02",
    //       name: "Blue Black Sweatshirts",
    //       category: [{ id: "1", name: "Shoes" }],
    //       colors: [{ id: "1", name: "black" }],
    //       description: "Some discription",
    //       discount: 0,
    //       mrp: 1259.72,
    //       cp: 0,
    //       sp: 0,
    //       images: [
    //         {
    //           id: "1",
    //           type: "top",
    //           src: product2,
    //         },
    //         {
    //           id: "2",
    //           type: "right",
    //           src: product1,
    //         },
    //       ],
    //     },
    //   ],
    //   banner: {
    //     id: "03",
    //     imageURL: banner1,
    //     title: "Some Title",
    //     priceRange: {
    //       startPrice: "₹129.69",
    //       endPrice: "₹1259.72",
    //     },
    //     description: [
    //       {
    //         id: "1",
    //         name: "Some important details",
    //       },
    //       {
    //         id: "2",
    //         name: "Some important details",
    //       },
    //     ],
    //   },
    // },
  ],
  usefulLinks: {
    name: "Useful links",
    links: [
      {
        name: "About",
        src: "/about",
      },
      {
        name: "Contact us",
        src: "/contact",
      },
    ],
  },
  termsOfUse: {
    name: "Terms of use",
    src: "/",
  },
  privacyPolicy: {
    name: "Privacy Policy",
    src: "/",
  },
};
